import { format } from 'date-fns';
import type { IntlShape } from 'react-intl';
import { formatSessionListDateShort } from '../../data/session-list/date-group';

const ENGLISH_RANGE_SEPARATOR = ' – ';
const JAPANESE_RANGE_SEPARATOR = '〜';

/**
 * Formats a session-filter range in the active display locale.
 * English stays on date-fns `dd MMM` so the caption keeps its zero-padded day
 * (`27 Sep – 03 Oct`); the shared short formatter would drop that to `3 Oct`.
 * Every other locale reuses that formatter — Gregorian calendar and native
 * digits for Arabic — with the Japanese wave dash as the range marker.
 */
export const formatSessionDateRange = (intl: IntlShape, from: Date, to: Date): string => {
  const locale = intl.locale.toLowerCase();

  if (locale.startsWith('en')) {
    return `${format(from, 'dd MMM')}${ENGLISH_RANGE_SEPARATOR}${format(to, 'dd MMM')}`;
  }

  const separator = locale.startsWith('ja')
    ? JAPANESE_RANGE_SEPARATOR
    : ENGLISH_RANGE_SEPARATOR;

  return `${formatSessionListDateShort(from, intl)}${separator}${formatSessionListDateShort(to, intl)}`;
};
